import { useState } from 'react';
import Skeleton from '@/common/components/skeleton/Skeleton';
import { ANALYTICS_EVENT } from '@/common/constants/analyticsEvents';
import { useAnalytics } from '@/common/contexts/AnalyticsContext';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { formatTranslation } from '@/common/utils/formatTranslation';
import ProfileDetailsModal from '@/pages/customer/home/components/profileDetailsModal/ProfileDetailsModal';
import ChatFeedback from '../chatFeedback/ChatFeedback';
import CompanionMediaGallery from './CompanionMediaGallery';
import {
	CompanionBio,
	CompanionChip,
	CompanionCloseArrow,
	CompanionCloseButton,
	CompanionTextBlock,
	CompanionGlass,
	CompanionMediaSection,
	CompanionMediaTitle,
	CompanionMiniProfile,
	CompanionName,
	CompanionPanelHeading,
	CompanionProfileImage,
	CompanionProfileStack,
	CompanionRoot,
} from './chatCompanion.styles';

const CompanionSidebar = ({
	person,
	imageSrc,
	conversationImages,
	openGallery,
	onClosePanel,
}) => {
	const t = useLanguageData('chat');
	const { trackAnalytics } = useAnalytics();
	const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

	const handleOpenProfileModal = () => {
		trackAnalytics(ANALYTICS_EVENT.CHAT.PROFILE_OPEN, {
			personId: person?._id ?? null,
		});
		setIsProfileModalOpen(true);
	};

	const totalImages = conversationImages.length;

	const tags = person?.person_config?.tags || [];
	const primaryTag = tags[0];
	const description =
		person?.person_config?.description
		|| person?.description
		|| t.noDescription;

	return (
		<CompanionRoot>
			<CompanionPanelHeading>
				<CompanionCloseButton
					type="button"
					onClick={onClosePanel}
					aria-label={t.hideProfilePanel}
				>
					<CompanionCloseArrow aria-hidden="true" />
				</CompanionCloseButton>
			</CompanionPanelHeading>
			<CompanionGlass>
				<CompanionMiniProfile>
					<CompanionProfileStack>
						{imageSrc ? (
							<CompanionProfileImage src={imageSrc} alt={person?.name} />
						) : (
							<Skeleton width="92px" height="122px" radius="12px" minWidth="92px" minHeight="122px" />
						)}
						<ChatFeedback
							person={person}
							variant="companion"
							onInfoClick={handleOpenProfileModal}
						/>
					</CompanionProfileStack>
					<CompanionTextBlock>
						<CompanionName>{person?.name}</CompanionName>
						<CompanionBio>{description}</CompanionBio>
					</CompanionTextBlock>
				</CompanionMiniProfile>
			</CompanionGlass>
			{primaryTag && <CompanionChip>{primaryTag}</CompanionChip>}
			<CompanionMediaSection>
				<CompanionMediaTitle>
					{formatTranslation(t.imagesCount, { count: totalImages })}
				</CompanionMediaTitle>
				<CompanionMediaGallery
					images={conversationImages}
					onOpenImage={openGallery}
				/>
			</CompanionMediaSection>
			{isProfileModalOpen && person && (
				<ProfileDetailsModal
					profile={person}
					onClose={() => setIsProfileModalOpen(false)}
					hideStartChat
					analyticsSource="chat"
				/>
			)}
		</CompanionRoot>
	);
};

export default CompanionSidebar;
